import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import "../assets/CSS/Dashboard.css";

function ViewCheckPoints() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({ searchQuery: "", fromDate: "", toDate: "" });
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [remarks, setRemarks] = useState({});
    // Logged-in user
 const user = JSON.parse(localStorage.getItem("userData")); // make sure it's loaded

  const toggleSidebar = () => setIsSidebarVisible(vis => !vis);

  const fetchCheckPoints = useCallback(async () => {
    try {
      const response = await axiosInstance.get("api/get-CheckPoint-FormData");
      const allData = response.data || [];
      setData(allData);
      setFilteredData(allData);
    } catch (error) {
      console.error("Error fetching checkpoints data:", error);
    }
  }, []);

  useEffect(() => {
    fetchCheckPoints();
  }, [fetchCheckPoints]);

  // Handle filter input changes
  const handleFilterChange = e => {
    const { name, value } = e.target;
    setFilters(f => ({ ...f, [name]: value }));
  };

  // Apply filters
  useEffect(() => {
    const { searchQuery, fromDate, toDate } = filters;
    const filtered = data.filter(item => {
      const created = new Date(item.CreatedAt);
      const matchesSearch =
        searchQuery === "" ||
        [item.Responsible_Person, item.Department, item.LOT_ID, item.ProcessName]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      const matchesDate =
        (fromDate === "" || created >= new Date(fromDate)) &&
        (toDate === "" || created <= new Date(toDate));
      return matchesSearch && matchesDate;
    });
    setFilteredData(filtered);
  }, [filters, data]);

  // Delete handler
  // const handleDelete = async id => {
  //   if (!window.confirm("Are you sure you want to delete this entry?")) return;
  //   try {
  //     await axiosInstance.delete(`/api/delete-checkpoint/${id}`);
  //     fetchCheckPoints();
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //     alert("Failed to delete entry");
  //   }
  // };

  // Approve entry
//   const handleApprove = async row => {
//     if (row.Status === "Approved") return;
//     try {
//       await axiosInstance.patch(
//         `/api/update-checkpoint-status/${row.id}`,
//         { ApprovedBy: supervisor, Status: "Approved" }
//       );
//       // refresh row state locally
//       setData(d => d.map(it => it.id === row.id ? { ...it, ApprovedBy: supervisor, Status: "Approved" } : it));
//       setFilteredData(fd => fd.map(it => it.id === row.id ? { ...it, ApprovedBy: supervisor, Status: "Approved" } : it));
//     } catch (err) {
//       console.error("Approve error:", err);
//       alert("Failed to approve");
//     }
//   };

     const handleApprove = async (id) => {
    try {
      // Disable button immediately by setting remarks state; we'll flip row.Status to “Approving...”
      setData((prev) =>
        prev.map((r) =>
          r.ID === id ? { ...r, Status: "Approving..." } : r
        )
      );

      await axiosInstance.patch(`/api/update-checkpoint-status/${id}`, {
        Status: "Approved",
        ApprovedBy: user?.Name || "Unknown",
      });

      // On success, set that remark’s Status to “Approved”
      setData((prev) =>
        prev.map((r) =>
          r.ID === id ? { ...r, Status: "Approved" } : r
        )
      );
      showAlert("Approved Successfully", "success");
       fetchCheckPoints();
    } catch (err) {
      console.error("Failed to approve remark:", err);
      // Optionally revert the “Approving...” to the previous value or show an alert
     
    }
  };


    const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };

 // Update remarks with debounce
  const handleRemarksBlur = (id, value) => {
    const trimmed = value.trim() || null;
    if (trimmed === data.find(r => r.id === id)?.Remarks) return;
    clearTimeout(window.remarkTimeout);
    window.remarkTimeout = setTimeout(async () => {
      try {
        await axiosInstance.patch(`/api/update-checkpoint-remarks/${id}`, { Remarks: trimmed });
        showAlert("Remarks updated", "success");
        fetchCheckPoints();
      } catch (err) {
        console.error("Remarks update error:", err);
        showAlert("Failed to update remarks", "danger");
      }
    }, 800);
  };

  const columns = [
    { name: "Responsible Person",width:"150px", selector: row => row.Responsible_Person, sortable: true, wrap: true },
    { name: "Department",width:"180px", selector: row => row.Department, sortable: true, wrap: true },
    { name: "LOT ID", selector: row => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.LOT_ID}
        >
        {row.LOT_ID}
        </span>
    ), sortable: true, wrap: true },
    // { name: "Process", selector: row => row.ProcessName, sortable: true },
    {
      name: "Checkpoint", width:"300px",
      selector: row => (
        <span data-bs-toggle="tooltip" data-bs-placement="top" title={row.CheckPoints}>
          {row.CheckPoints}
        </span>
      ),
      sortable: true,
      wrap: true
    },
    { name: "Details",width:"200px", selector: row =>(
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.OtherDetails}
        >
     {row.OtherDetails}
        </span>
    ), wrap: true },
    { name: "Evidence", width: "100px", selector: row => {
      const IMAGE_BASE_URL = process.env.REACT_APP_API_BASE_PATH || "http://localhost:5000";
      return row.EvidencePhoto ? (
        <a href={`${IMAGE_BASE_URL}/${row.EvidencePhoto}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary py-0 px-2" style={{ fontSize: "12px" }}>
          <i className="bi bi-image"></i>
        </a>
      ) : (
        <span className="text-muted small">N/A</span>
      )
    }, sortable: false },
  
    {
      name: "Remarks",
      cell: row => (
        <textarea
          className="form-control"
          rows={1}
          style={{ fontSize: '12px', width: '150px' }}
          // value={remarks[row.id] || ''}
          value={
            remarks[row.id] !== undefined
              ? remarks[row.id]
              : row.Remarks || ""
          }
          onChange={e => setRemarks(prev => ({ ...prev, [row.id]: e.target.value }))}
          onBlur={e => handleRemarksBlur(row.id, e.target.value)}
          placeholder="Enter Remark"
        />
      ),
      sortable: true
    },
     { name: "Created By",width:"150px", selector: row => row.CreatedBy, sortable: true },
     { name: "Created At",width:"150px", selector: row => row.CreatedAt, sortable: true },
      { name: "Approve Within",width:"150px", selector: row => row.ApproveWithin, sortable: true },
      { name: "Approval",
      // In this column, if row.Status === "Approved", show green “Approved” text.
      // If row.Status === "Approving...", disable button and show “Approving…”.
      // Otherwise show a clickable “Approve” button.
      cell: (row) => {
        if (row.Status === "Approved") {
          return (
            <span style={{ 
              backgroundColor: "green", 
              color: "white", 
              padding: "4px 12px", 
              borderRadius: "20px", 
              fontSize: "12px", 
              fontWeight: "bold",
              display: "inline-block",
              textAlign: "center",
              minWidth: "80px",
              whiteSpace: "nowrap"
            }}>
              Approved
            </span>
          );
        } else if (row.Status === "Approving...") {
          return (
            <button className="btn btn-sm btn-secondary" disabled>
              Approving…
            </button>
          );
        } else {
          return (
            <button
              className="btn btn-sm btn-outline-success"
              onClick={() => handleApprove(row.id)}
            >
              Approve
            </button>
          );
        }
      },
      ignoreRowClick: true, // so clicking the button doesn’t select the row
      allowOverflow: true,
      button: true,
    },

    //   {
    //   name: "Actions",
    //   cell: row => (
    //     <button
    //       className="btn btn-sm btn-danger"
    //       onClick={() => handleDelete(row.id)}
    //     >
    //       Delete
    //     </button>
    //   )
    // }
  ];

  return (
    <div className="d-flex dashboard" style={{ backgroundColor: "#f4f7f6", minHeight: "100vh" }}>
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1 d-flex flex-column" style={{ width: isSidebarVisible ? "calc(100vw - 250px)" : "100vw", transition: "width 0.3s ease" }}>
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content", marginTop: "75px" }}>
          
          <div className="card shadow-sm border-0 rounded-4 p-4 mb-4" style={{ backgroundColor: "rgba(255,255,255,0.85)", backdropFilter: "blur(10px)" }}>
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
              <div>
                <h3 className="fw-bold mb-1" style={{ color: "#0d6efd" }}>
                  <i className="bi bi-ui-checks-grid me-2"></i>Checkpoint Approvals
                </h3>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Review and approve submitted checkpoints from various departments</p>
              </div>
            </div>

            {/* Filter Section */}
            <div className="d-flex flex-wrap gap-3 mb-4 p-3 rounded-3" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}>
              <div className="flex-grow-1" style={{ minWidth: "250px" }}>
                <div className="input-group shadow-sm">
                  <span className="input-group-text bg-white border-end-0 text-muted"><i className="bi bi-search"></i></span>
                  <input
                    type="text"
                    name="searchQuery"
                    value={filters.searchQuery}
                    onChange={handleFilterChange}
                    className="form-control border-start-0 ps-0"
                    placeholder="Search by text..."
                  />
                </div>
              </div>
              <div style={{ minWidth: "200px" }}>
                <div className="input-group shadow-sm">
                  <span className="input-group-text bg-white text-muted"><i className="bi bi-calendar"></i>&nbsp;From</span>
                  <input
                    type="date"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div style={{ minWidth: "200px" }}>
                <div className="input-group shadow-sm">
                  <span className="input-group-text bg-white text-muted"><i className="bi bi-calendar"></i>&nbsp;To</span>
                  <input
                    type="date"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="border rounded-4 overflow-hidden shadow-sm bg-white custom-scrollbar-table">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
                persistTableHead
                customStyles={{
                  headRow: { style: { backgroundColor: '#212529', color: '#ffffff', fontWeight: 'bold', fontSize: '14px' } },
                  cells: { style: { padding: '12px', fontSize: '13.5px' } },
                }}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default ViewCheckPoints;
